import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, Clock } from 'lucide-react';
import { businessInfo } from '../mock';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Academy', path: '/academy' },
    { name: 'Services', path: '/services' },
    { name: 'Our Owners', path: '/team' },
    { name: 'Our Team', path: '/graduates' },
    { name: 'Success Stories', path: '/success-stories' },
    { name: 'Reviews', path: '/reviews' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Top bar */}
      <div className="bg-sage-50 border-b border-sage-200">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap items-center justify-between py-2 text-sm">
            <div className="flex items-center gap-4 text-sage-700">
              <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-1.5 hover:text-sage-900 transition-colors">
                <Phone size={14} />
                <span className="hidden sm:inline">{businessInfo.phone}</span>
              </a>
              <a href={`mailto:${businessInfo.email}`} className="flex items-center gap-1.5 hover:text-sage-900 transition-colors">
                <Mail size={14} />
                <span className="hidden md:inline">{businessInfo.email}</span>
              </a>
            </div>
            <div className="flex items-center gap-1.5 text-sage-700">
              <Clock size={14} />
              <span className="hidden sm:inline">{businessInfo.hours.weekdays}</span>
              <span className="sm:hidden">Mon-Fri: 9am-6pm</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main navbar */}
      <nav className="bg-white shadow-md sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_pups-dreams-spa/artifacts/45b08864_2482C0A8-4B54-4030-AAC1-5144E8515AFD%203.jpg" 
                alt="Pups & Dreams Spa & Academy" 
                className="h-14 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2 rounded-lg font-medium transition-all ${
                    isActive(link.path)
                      ? 'bg-sage-100 text-sage-900'
                      : 'text-sage-700 hover:bg-sage-50 hover:text-sage-900'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {/* Book Now Button - Desktop */}
            <Link
              to="/contact"
              className="hidden lg:block bg-gradient-to-r from-sage-500 to-sage-600 text-white px-6 py-2.5 rounded-lg font-semibold hover:from-sage-600 hover:to-sage-700 transition-all shadow-md hover:shadow-lg"
            >
              Book Now
            </Link>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="lg:hidden p-2 rounded-lg text-sage-700 hover:bg-sage-50 transition-colors"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isOpen && (
            <div className="lg:hidden py-4 border-t border-sage-200">
              <div className="flex flex-col gap-2">
                {navLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => setIsOpen(false)}
                    className={`px-4 py-3 rounded-lg font-medium transition-all ${
                      isActive(link.path)
                        ? 'bg-sage-100 text-sage-900'
                        : 'text-sage-700 hover:bg-sage-50'
                    }`}
                  >
                    {link.name}
                  </Link>
                ))}
                <Link
                  to="/contact"
                  onClick={() => setIsOpen(false)}
                  className="mt-2 bg-gradient-to-r from-sage-500 to-sage-600 text-white px-4 py-3 rounded-lg font-semibold text-center hover:from-sage-600 hover:to-sage-700 transition-all"
                >
                  Book Now
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
